import "./Gallery.css"
import Title from "../Title/Title"
import pic1 from "../../images/Memories/pic1.jpeg"
import pic2 from "../../images/Memories/pic2.jpeg"
import pic3 from "../../images/Memories/pic3.jpeg"
import pic4 from "../../images/Memories/pic4.jpeg"
import pic5 from "../../images/Memories/pic5.jpeg"
import pic6 from "../../images/Memories/pic6.jpeg"
import pic7 from "../../images/Memories/pic7.jpeg"
import pic8 from "../../images/Memories/pic8.jpeg"
import pic9 from "../../images/Memories/pic9.jpeg"
const Gallery = () => {
  return ( 
      <>
        <Title title={"Memories"} style={{margin: "100px 0"}}/>
        <div className="mob-gallery-container">
          <img src={pic3}/>
          <img src={pic1}/>
          <img src={pic2} />
          <img src={pic4} />
          <img src={pic5} />
          <img src={pic6}  />
        </div>
      </>
   );
}
 
export default Gallery;